export function SectionLabel({ children, onDark = false }: { children: string; onDark?: boolean }) {
  return (
    <div className="flex items-center gap-3">
      <span className="hazard-rule h-[3px] w-9" aria-hidden="true" />
      <span className={onDark ? "label-eyebrow text-amber-brand" : "label-eyebrow text-amber-text"}>
        {children}
      </span>
    </div>
  );
}
